import React from "react";
import { defineMessages } from "react-intl";
import { makeStyles } from "tss-react/mui";
import { Button, IconButton } from "../button/Buttons.js";
import "../button/EditButton.js";
import { Icon } from "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
import "../../localization/MessageLocalizer.js";
import "../../localization/LocaleProvider.js";
import { sharedLocalization } from "../../localization/sharedResources.js";
const localized = defineMessages({
  resetButtonLabel: {
    id: "FilterGroupButtons_resetButtonLabel",
    defaultMessage: "Reset"
  }
});
const useStyles = makeStyles()((theme) => {
  return {
    filterGroupButtonsContainer: {
      display: "inline-flex",
      gap: theme.spacing(1.25),
      [theme.breakpoints.down("md")]: {
        flexWrap: "wrap"
      }
    },
    filterGroupButtonsButton: {
      borderRadius: theme.custom.defaultBorderRadius * 2,
      maxHeight: theme.custom.denseButtonHeight
    },
    filterGroupButtonsButtonIcon: {
      fontSize: `${theme.spacing(1.5)} !important`
    },
    filterGroupButtonsExpandButton: {
      minWidth: "unset",
      color: theme.palette.primary.main
    },
    filterGroupButtonsResetButtonIcon: {
      fontSize: `${theme.spacing(2)} !important`,
      color: theme.palette.text.secondary
    }
  };
});
function FilterGroupButtons({
  isMobile,
  isFilterChanged,
  hasExpandButton,
  hasSubmitButton,
  isExpanded,
  onCollapse,
  onExpand,
  onReset,
  isDataLoading
}) {
  const { classes, cx } = useStyles();
  return hasExpandButton || hasSubmitButton ? /* @__PURE__ */ React.createElement("div", { className: classes.filterGroupButtonsContainer }, !isMobile && hasExpandButton ? isExpanded ? /* @__PURE__ */ React.createElement(
    Button,
    {
      label: sharedLocalization.collapseButtonLabel,
      onClick: onCollapse,
      className: cx(classes.filterGroupButtonsExpandButton, classes.filterGroupButtonsButton),
      endIcon: /* @__PURE__ */ React.createElement(Icon, { icon: CustomIcon.ArrowUp, className: classes.filterGroupButtonsButtonIcon })
    }
  ) : /* @__PURE__ */ React.createElement(
    Button,
    {
      label: sharedLocalization.expandButtonLabel,
      onClick: onExpand,
      className: cx(classes.filterGroupButtonsExpandButton, classes.filterGroupButtonsButton),
      endIcon: /* @__PURE__ */ React.createElement(Icon, { icon: CustomIcon.ArrowDown, className: classes.filterGroupButtonsButtonIcon })
    }
  ) : null, hasSubmitButton ? /* @__PURE__ */ React.createElement(
    Button,
    {
      type: "submit",
      color: "primary",
      label: sharedLocalization.submitButtonLabel,
      className: classes.filterGroupButtonsButton,
      startIcon: /* @__PURE__ */ React.createElement(Icon, { icon: CustomIcon.Search, className: classes.filterGroupButtonsButtonIcon }),
      loading: isDataLoading,
      disabled: !isFilterChanged
    }
  ) : null, onReset && /* @__PURE__ */ React.createElement(
    Button,
    {
      label: localized.resetButtonLabel,
      onClick: onReset,
      className: classes.filterGroupButtonsButton,
      startIcon: /* @__PURE__ */ React.createElement(Icon, { icon: CustomIcon.Reset, className: classes.filterGroupButtonsResetButtonIcon })
    }
  ), isMobile && hasExpandButton ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      variant: "round",
      iconClassName: CustomIcon.Filter,
      iconFontSize: 16,
      onClick: isExpanded ? onCollapse : onExpand
    }
  )) : null) : null;
}
export {
  FilterGroupButtons
};
//# sourceMappingURL=FilterGroupButtons.js.map
